import {useState} from 'react';
import {useApp} from '../../../contexts/AppContext';
import SelectModal, {SelectedLabel} from '../SelectModal';

export function CountrySelect({country = 'GB', onSelectCountry}) {
  const {state} = useApp();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const countries = state.countries || [];
  if (!country) {
    country = 'GB';
  }
  let selectedIndex = -1;
  let c = countries.find((_c, i) => {
    if (_c.country == country) {
      selectedIndex = i;
      return true;
    }
    return false;
  });
  if (!c) {
    return '';
  }

  const onClick = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const itemSelect = (index) => {
    setModalIsOpen(false);
    if (index >= 0) {
      onSelectCountry(countries[index].country);
    } else {
      onSelectCountry('');
    }
  };

  return (
      <>
        <SelectedLabel onClick={onClick}>{c.country_name}</SelectedLabel>
        <SelectModal
            title="Country"
            candidates={countries.map((c) => c.country_name)}
            selectedIndex={selectedIndex}
            closeModal={closeModal}
            modalIsOpen={modalIsOpen}
            itemSelect={itemSelect}
        />
      </>
  );
}

export function AreaSelect({country, area = '', onSelectArea}) {
  const {state} = useApp();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const countries = state.countries || [];
  if (!country) {
    country = 'GB';
  }
  let c = countries.find((_c) => _c.country == country);
  if (!c) {
    return '';
  }
  let selectedIndex = -1;
  let areas = c.areas || [];
  let a = areas.find((_a, i) => {
    if (_a.area == area) {
      selectedIndex = i;
      return true;
    }
    return false;
  });
  a = a || null;

  const onClick = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const itemSelect = (index) => {
    setModalIsOpen(false);
    if (index >= 0) {
      onSelectArea(areas[index].area);
    } else {
      onSelectArea('');
    }
  };

  let name = (a && a.area_name) || 'Select one';

  return (
      <>
        <SelectedLabel onClick={onClick}>{name}</SelectedLabel>
        <SelectModal
            title="Area"
            candidates={areas.map((a) => a.area_name)}
            selectedIndex={selectedIndex}
            closeModal={closeModal}
            modalIsOpen={modalIsOpen}
            itemSelect={itemSelect}
        />
      </>
  );
}
